var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230,
    height: 458.14,
    viewBox: "0 0 230 458.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_1_",
    "data-name": "mobile (1)",
    transform: "translate(-141 -26.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22395",
    "data-name": "Group 22395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24312",
    "data-name": "Path 24312",
    d: "M155.827,448.406l.5,3.067a8.436,8.436,0,0,0,8.055,6.858h111.17v19.263h-108.8a10.923,10.923,0,0,1-10.918-10.918Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24313",
    "data-name": "Path 24313",
    d: "M356.173,448.406l-.5,3.067a8.436,8.436,0,0,1-8.055,6.858H236.452v19.263h108.8a10.923,10.923,0,0,0,10.918-10.918Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22396",
    "data-name": "Group 22396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24314",
    "data-name": "Path 24314",
    d: "M155.827,63.594l.5-3.067a8.436,8.436,0,0,1,8.055-6.858h51.17V34.406h-48.8a10.923,10.923,0,0,0-10.918,10.918Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22397",
    "data-name": "Group 22397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24315",
    "data-name": "Path 24315",
    d: "M273.61,38.71a2.5,2.5,0,1,1,0,5H238.39a2.5,2.5,0,0,1,0-5Zm82.563,24.884-.5-3.067a8.436,8.436,0,0,0-8.055-6.858H206.452V34.406h138.8a10.923,10.923,0,0,1,10.918,10.918ZM286.49,41.185a4.653,4.653,0,1,1,4.653,4.652A4.655,4.655,0,0,1,286.49,41.185Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24316",
    "data-name": "Path 24316",
    d: "M295.735,41.93H338.69A17.31,17.31,0,0,1,356,59.25v393.5a17.31,17.31,0,0,1-17.31,17.32H173.31A17.31,17.31,0,0,1,156,452.75V59.25a17.31,17.31,0,0,1,17.31-17.32h62.684a2.513,2.513,0,0,1-.1-.72,2.509,2.509,0,0,1,2.5-2.5h35.22a2.506,2.506,0,0,1,2.4,3.22H286.55a4.653,4.653,0,1,1,9.245-.745,4.585,4.585,0,0,1-.06.745Zm-122.425-15H338.69A32.316,32.316,0,0,1,371,59.25v393.5a32.316,32.316,0,0,1-32.31,32.32H173.31A32.316,32.316,0,0,1,141,452.75V59.25a32.316,32.316,0,0,1,32.31-32.32Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePreview);
export default __webpack_public_path__ + "static/media/mobile-preview.9b5e4abc1d68c1751b2826e78844ec8c.svg";
export { ForwardRef as ReactComponent };